import { useEffect } from "react";
import { useRouter } from "next/router";
import { useGetLoginStatus } from "lib/auth";

import FAQs from "elements/Pricing-FAQs";
import SignupContent from "elements/Signup";

const REDIRECT_URL = process.env.NEXT_PUBLIC_DAISHO_APP_LINK;

const Page = () => {
  const router = useRouter();
  const loggedIn = useGetLoginStatus();

  const action = router.query.action as "trial" | "sign-up";

  useEffect(() => {
    if (loggedIn) {
      const { next, ...rest } = router.query;

      if (next) {
        router.push({ pathname: next as string, query: rest });
      } else {
        setTimeout(() => {
          document.location.href = REDIRECT_URL;
        }, 15000);
      }
    }
  }, [loggedIn, router]);

  const { next, plan } = router.query;
  const signupFromPricing = next === "/pricing" && !!plan;

  return (
    <div className="flex flex-col min-h-screen overflow-hidden">
      {/*  Page content */}
      <main className="flex-grow">
        <section className="bg-gradient-to-b from-gray-100 to-white">
          <div className="max-w-6xl mx-auto px-4 sm:px-6">
            <div className="pt-32 pb-12 md:pt-40 md:pb-20">
              {/* Page header */}
              <div className="max-w-3xl mx-auto text-center pb-12 md:pb-20">
                <h1 className="h1">Try Daisho free for 15 days.</h1>
                <p className="text-brand-600 font-medium">
                  Standard Plan. No Credit Card Required. Completely Risk Free.
                </p>
              </div>
              <SignupContent
                action={action || (signupFromPricing ? "sign-up" : "trial")}
              />
            </div>
          </div>
        </section>
        <FAQs page="sign-up" />
      </main>
    </div>
  );
};

export default Page;
